<template>
  <div class="mobile-ourteam-box">
    <div class="mobile-text-box">
      <div class="mobile-title-box">
        <div class="mobile-en-title">TEAM</div>
        <div class="mobile-cn-title">我们的团队</div>
      </div>
      <div class="mobile-text">
        <p>山木枝信息技术有限公司是一个致力于技术和商业相融合的创意团队。</p>
        <p>专注于用户体验设计与品牌数字革新的解决方案。</p>
        <p>
          富含正能量的一群不拘泥于传统，爱思考的我们坚信正派与务实的经营之道让我们走得更远。
        </p>
      </div>
    </div>
    <img
      class="mobile-banner"
      src="@/assets/mobile/team/banner.png"
      alt="banner"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
.mobile-ourteam-box .mobile-text-box {
  padding: 3.0625rem 3rem;
}

.mobile-ourteam-box .mobile-text-box .mobile-title-box .mobile-en-title {
  font-weight: 300;
  font-size: 1.125rem;
  color: #ffffff;
  line-height: 1.5rem;
  opacity: 0.54;
}

.mobile-ourteam-box .mobile-text-box .mobile-title-box .mobile-cn-title {
  font-weight: 300;
  font-size: 1.875rem;
  color: #ffcfa0;
  line-height: 1.5rem;
  margin: 0.75rem 0 1.9375rem 0;
}

.mobile-ourteam-box .mobile-text-box .mobile-text {
  font-weight: 400;
  font-size: 1.625rem;
  color: #ffffff;
}

.mobile-ourteam-box .mobile-text-box .mobile-text p {
  line-height: 3.3125rem;
}

.mobile-ourteam-box .mobile-banner {
  width: 46.875rem;
  height: 26.5625rem;
}
</style>
